import React, { useEffect } from 'react'
import Footer from '../../Components/Footer'
import SearchDOMAINS from './SearchDOMAINS'
import { setPageTitle } from '../../Utils/brand'

export default function Home() {
    useEffect(() => {
        setPageTitle();
    }, []);

    return (
        <main className="pt-20"> {/* Added padding-top for sticky navbar */}
            <section id="home">
                <SearchDOMAINS />
            </section>

            <Footer />
        </main>
    )
}